{
  "es": {
    "notification": {
      "actions": {
        "delete": "Eliminar notificación",
        "deleteAll": "Eliminar todo",
        "markAllAsRead": "Marcar todo como leído",
        "mark_as_read": "Marcar como leído",
        "mark_as_unread": "Marcar como no leído"
      },
      "customers": {
        "announcement": {
          "create": "creó una novedad. | creó {group_notification_count} novedades. |_| creó {group_notification_count} novedades."
        },
        "decision": {
          "message": {
            "create": "envió un mensaje nuevo en la conversación <i>'{group_name}'</i>. | envió {group_notification_count} mensajes nuevos en la conversación <i>'{group_name}'</i>. |_| envió {group_notification_count} mensajes nuevos en la conversación <i>'{group_name}'</i>."
          },
          "published": {
            "customer": "añadió la decisión <i>'{notifiable_name}'</i>."
          },
          "relaunched": "volvió a poner disponible la decisión <i>'{notifiable_name}'</i>."
        },
        "decision_document": {
          "create": "subió el documento <i>'{notifiable_name}'</i> en la decisión <i>'{group_name}'</i>. | subió {group_notification_count} documentos en la decisión <i>'{group_name}'</i>. |_| subió {group_notification_count} documentos en la decisión <i>'{group_name}'</i>."
        },
        "decision_proposal": {
          "approved": "aprobó la propuesta <i>'{notifiable_name}'</i> en la decisión <i>'{group_name}'</i>. | aprobó {group_notification_count} propuestas en la decisión <i>'{group_name}'</i>. | aprobó {group_notification_count} propuestas en la decisión <i>'{group_name}'</i>.",
          "create": "creó la propuesta <i>'{notifiable_name}'</i> en la decisión <i>'{group_name}'</i>. | creó {group_notification_count} propuestas en la decisión <i>'{group_name}'</i>. | creó {group_notification_count} propuestas en la decisión <i>'{group_name}'</i>.",
          "edit_approved": "editó la propuesta aprobada <i>'{notifiable_name}'</i> en la decisión <i>'{group_name}'</i>. | editó {group_notification_count} propuestas aprobadas en la decisión <i>'{group_name}'</i>. | editó {group_notification_count} propuestas aprobadas en la decisión <i>'{group_name}'</i>.",
          "relaunched": "volvió a poner disponible la propuesta <i>'{notifiable_name}'</i> para la que pediste cambios | volvió a poner disponibles {group_notification_count} propuestas en la decisión <i>'{group_name}'</i> para las que pediste cambios | volvió a poner disponibles {group_notification_count} propuestas en la decisión <i>'{group_name}'</i> para las que pediste cambios"
        },
        "document": {
          "create": "subió el documento <i>'{notifiable_name}'</i>. | subió {group_notification_count} documentos. |_| subió {group_notification_count} documentos.",
          "installment": {
            "create": "añadió la factura <i>'{notifiable_name}'</i> a una cuota. | añadió {group_notification_count} facturas a una cuota. |_| añadió {group_notification_count} facturas a una cuota."
          },
          "invoice": {
            "create": "subió la factura <i>'{notifiable_name}'</i>. | subió {group_notification_count} facturas. |_| subió {group_notification_count} facturas."
          },
          "proposal": {
            "create": "añadió el documento <i>'{notifiable_name}'</i> a la propuesta <i>'{group_name}'</i>. | añadió {group_notification_count} documentos a la propuesta <i>'{group_name}'</i>. |_| añadió {group_notification_count} documentos a la propuesta <i>'{group_name}'</i>."
          }
        },
        "export": {
          "create": "Tus datos exportados están listos para descargar."
        },
        "installment": {
          "published": "hizo disponible la cuota <i>'{notifiable_name}'</i>.  | hizo disponibles {group_notification_count} cuotas. | hizo disponibles {group_notification_count} cuotas.",
          "status": {
            "changed": "cambió el estado de la cuota <i>'{notifiable_name}'</i> a <i>'{status}'</i>.  | cambió el estado de {group_notification_count} cuotas. | cambió el estado de {group_notification_count} cuotas."
          }
        },
        "issue": {
          "approval": {
            "create": "solicitó la aprobación de la incidencia <i>'{notifiable_name}'</i> | solicitó la aprobación de {group_notification_count} incidencias. | solicitó la aprobación de {group_notification_count} incidencias."
          },
          "create": "creó la incidencia <i>'{notifiable_name}'</i> | creó {group_notification_count} incidencias | creó {group_notification_count} incidencias",
          "message": {
            "create": "envió un mensaje nuevo en la conversación <i>'{group_name}'</i>. | envió {group_notification_count} mensajes nuevos en la conversación <i>'{group_name}'</i>. |_| envió {group_notification_count} mensajes nuevos en la conversación <i>'{group_name}'</i>."
          },
          "status": {
            "update": "actualizó el estado de <i>'{notifiable_name}'</i> a <i>'{status}'</i> | actualizó el estado de {group_notification_count} incidencias. | actualizó el estado de {group_notification_count} incidencias."
          }
        },
        "question": {
          "create": "creó la pregunta <i>'{notifiable_name}'</i> en la FAQ <i>'{group_name}'</i>. | creó {group_notification_count} preguntas en la FAQ <i>'{group_name}'</i>. |_| creó {group_notification_count} preguntas en la FAQ <i>'{group_name}'</i>."
        },
        "reminder": {
          "decision": {
            "due": "No olvides tomar una decisión sobre <i>'{notifiable_name}'</i>."
          },
          "installment": {
            "due": "No olvides realizar un pago de <i>'{notifiable_name}'</i>."
          }
        },
        "survey": {
          "published": "quiere tu opinión sobre <i>'{group_name}'</i>."
        },
        "task_assignment": {
          "confirmation": {
            "requested": "te pide que confirmes <i>'{notifiable_name}'</i>."
          },
          "upload": {
            "requested": "te pide que subas un documento para <i>'{notifiable_name}'</i>."
          }
        },
        "ticket": {
          "create": "inició la conversación <i>'{notifiable_name}'</i>.",
          "message": {
            "create": "envió un mensaje nuevo en la conversación <i>'{group_name}'</i>. | envió {group_notification_count} mensajes nuevos en la conversación <i>'{group_name}'</i>. |_| envió {group_notification_count} mensajes nuevos en la conversación <i>'{group_name}'</i>.",
            "move": "movió tu mensaje a la conversación <i>'{group_name}'</i>"
          }
        },
        "ticket_document": {
          "create": "subió el documento <i>'{notifiable_name}'</i> en la conversación <i>'{group_name}'</i>. | subió {group_notification_count} documentos en la conversación <i>'{group_name}'</i>. |_| subió {group_notification_count} documentos en la conversación <i>'{group_name}'</i>."
        }
      },
      "employees": {
        "announcement": {
          "create": "creó una novedad. | creó {group_notification_count} novedades en <i>'{group_name}'</i>. |_| creó {group_notification_count} novedades en <i>'{group_name}'</i>."
        },
        "conversation_agent": {
          "activated": "ha activado el asistente de IA. Puedes desactivarlo en la configuración."
        },
        "decision": {
          "mention": {
            "create": "te mencionó en la conversación <i>'{group_name}'</i>. | te mencionó en {group_notification_count} mensajes en la conversación <i>'{group_name}'</i>. |_| te mencionó en {group_notification_count} mensajes en la conversación <i>'{group_name}'</i>."
          },
          "message": {
            "create": "envió un mensaje nuevo en la conversación <i>'{group_name}'</i>. | envió {group_notification_count} mensajes nuevos en la conversación <i>'{group_name}'</i>. |_| envió {group_notification_count} mensajes nuevos en la conversación <i>'{group_name}'</i>."
          },
          "not_interested": "no muestra interés en la decisión <i>'{notifiable_name}'</i>.",
          "responsible": {
            "update": "te asignó como responsable de la decisión <i>'{notifiable_name}'</i>"
          }
        },
        "decision_document": {
          "create": "subió el documento <i>'{notifiable_name}'</i> en la decisión <i>'{group_name}'</i>. | subió {group_notification_count} documentos en la decisión <i>'{group_name}'</i>. |_| subió {group_notification_count} documentos en la decisión <i>'{group_name}'</i>."
        },
        "decision_proposal": {
          "approved": "aprobó la propuesta <i>'{notifiable_name}'</i> en la decisión <i>'{group_name}'</i>. | aprobó {group_notification_count} propuestas en la decisión <i>'{group_name}'</i>. |_| aprobó {group_notification_count} propuestas en la decisión <i>'{group_name}'</i>.",
          "create": "creó la propuesta <i>'{notifiable_name}'</i> en la decisión <i>'{group_name}'</i>. | creó {group_notification_count} propuestas en la decisión <i>'{group_name}'</i>. |_| creó {group_notification_count} propuestas en la decisión <i>'{group_name}'</i>.",
          "requested_changes": "solicita cambios para la propuesta <i>'{notifiable_name}'</i> en la decisión <i>'{group_name}'</i>. | solicita cambios para {group_notification_count} propuestas en la decisión <i>'{group_name}'</i>. |_| solicita cambios para {group_notification_count} propuestas en la decisión <i>'{group_name}'</i>."
        },
        "document": {
          "create": "subió el documento <i>'{notifiable_name}'</i> en el directorio <i>'{group_name}'</i>. | subió {group_notification_count} documentos en el directorio <i>'{group_name}'</i>. |_| subió {group_notification_count} documentos en el directorio <i>'{group_name}'</i>.",
          "employee_create": "subió el documento <i>'{notifiable_name}'</i> en el directorio <i>'{group_name}'</i>. | subió {group_notification_count} documentos en el directorio <i>'{group_name}'</i>. |_| subió {group_notification_count} documentos en el directorio <i>'{group_name}'</i>.",
          "proposal": {
            "create": "añadió el documento <i>'{notifiable_name}'</i> a la propuesta <i>'{group_name}'</i>. | añadió {group_notification_count} documentos a la propuesta <i>'{group_name}'</i>. |_| añadió {group_notification_count} documentos a la propuesta <i>'{group_name}'</i>."
          }
        },
        "email_conversation": {
          "client": {
            "create": "recibió un correo entrante <i>'{notifiable_name}'</i>. | recibió {group_notification_count} correos entrantes. |_| recibió {group_notification_count} correos entrantes."
          },
          "project": {
            "create": "recibió un correo entrante <i>'{notifiable_name}'</i>. | recibió {group_notification_count} correos entrantes. |_| recibió {group_notification_count} correos entrantes."
          }
        },
        "export": {
          "create": "Tus datos exportados están listos para descargar."
        },
        "issue": {
          "approved": "aprobó la incidencia <i>'{notifiable_name}'</i> de la unidad <i>'{level_name}'</i>. | aprobó {group_notification_count} incidencias'</i>. |_| aprobó {group_notification_count} incidencias.",
          "create": "creó una incidencia nueva para la unidad <i>{level_name}</i> | creó {group_notification_count} incidencias nuevas para <i>{level_name}</i> |_| creó {group_notification_count} incidencias nuevas para <i>{level_name}</i>",
          "mention": {
            "create": "te mencionó en la conversación <i>'{group_name}'</i>. | te mencionó en {group_notification_count} mensajes en la conversación <i>'{group_name}'</i>. |_| te mencionó en {group_notification_count} mensajes en la conversación <i>'{group_name}'</i>."
          },
          "message": {
            "create": "envió un mensaje nuevo en la conversación <i>'{group_name}'</i>. | envió {group_notification_count} mensajes nuevos en la conversación <i>'{group_name}'</i>. |_| envió {group_notification_count} mensajes nuevos en la conversación <i>'{group_name}'</i>."
          },
          "rejected": "rechazó la incidencia <i>'{notifiable_name}'</i> de la unidad <i>'{level_name}'</i>. | rechazó {group_notification_count} incidencias'</i>. |_| rechazó {group_notification_count} incidencias."
        },
        "issue_list": {
          "responsible": {
            "update": "te asignó como responsable de la lista de incidencias <i>'{notifiable_name}'</i>."
          }
        },
        "question": {
          "create": "creó la pregunta <i>'{notifiable_name}'</i> en la FAQ <i>'{group_name}'</i>. | creó {group_notification_count} preguntas en la FAQ <i>'{group_name}'</i>. |_| creó {group_notification_count} preguntas en la FAQ <i>'{group_name}'</i>."
        },
        "survey_answer": {
          "create": "respondió <i>'{group_name}'</i>."
        },
        "task_assignment": {
          "completed": "ha completado <i>'{notifiable_name}'</i>.",
          "confirmation": {
            "requested": "te pide que confirmes <i>'{notifiable_name}'</i>."
          },
          "upload": {
            "requested": "te pide que subas un documento para <i>'{notifiable_name}'</i>."
          }
        },
        "ticket": {
          "create": "inició la conversación <i>'{notifiable_name}'</i>.",
          "mention": {
            "create": "te mencionó en la conversación <i>'{group_name}'</i>. | te mencionó en {group_notification_count} mensajes en la conversación <i>'{group_name}'</i>. |_| te mencionó en {group_notification_count} mensajes en la conversación <i>'{group_name}'</i>."
          },
          "message": {
            "create": "envió un mensaje nuevo en la conversación <i>'{group_name}'</i>. | envió {group_notification_count} mensajes nuevos en la conversación <i>'{group_name}'</i>. |_| envió {group_notification_count} mensajes nuevos en la conversación <i>'{group_name}'</i>."
          },
          "responsible": {
            "bulk_update": "te transfirió la responsabilidad de las conversaciones del proyecto <i>'{project_name}'</i> desde <i>{responsible_old_name}</i>.",
            "update": "te asignó la conversación <i>'{notifiable_name}'</i>."
          }
        },
        "ticket_document": {
          "create": "subió el documento <i>'{notifiable_name}'</i> en la conversación <i>'{group_name}'</i>. | subió {group_notification_count} documentos en la conversación <i>'{group_name}'</i>. |_| subió {group_notification_count} documentos en la conversación <i>'{group_name}'</i>."
        },
        "todo": {
          "assign": "te asignó la tarea <i>'{notifiable_name}'</i> en la lista <i>'{group_name}'</i>. | te asignó {group_notification_count} tareas en la lista <i>'{group_name}'</i>. | te asignó la tarea <i>'{notifiable_name}'</i> en la lista <i>'{group_name}'</i>. | te asignó {group_notification_count} tareas en la lista <i>'{group_name}'</i>."
        }
      },
      "labels": {
        "all": "Todos los proyectos",
        "allDecisions": "Todas las decisiones",
        "allStatuses": "Todos",
        "compactView": "Vista compacta",
        "expandedView": "Vista expandida",
        "filter": "Filtro",
        "hideDecisionFilter": "Ocultar filtro de decisiones",
        "hideExtraFilters": "Ocultar filtros adicionales",
        "noNewNotification": "¡Ya estás al día!",
        "noResults": "Sin resultados. ¡Prueba con otra cosa!",
        "none": "Actualmente no tienes ninguna notificación.",
        "notification_level_name_asc": "Unidad A-Z",
        "notification_level_name_desc": "Unidad Z-A",
        "pinSidebar": "Fijar barra lateral",
        "showDecisionFilter": "Mostrar filtro de decisiones",
        "showExtraFilters": "Mostrar filtros adicionales",
        "sort": "Ordenar por",
        "status": "Estado",
        "unpinSidebar": "Desfijar barra lateral",
        "unreadOnly": "Solo no leídas",
        "updated_at_asc": "Más antiguas primero",
        "updated_at_desc": "Más recientes primero"
      },
      "other_user": "y 1 más",
      "other_users": "y 1 más | y {count} más",
      "partners": {
        "decision": {
          "message": {
            "create": "envió un mensaje nuevo en la conversación <i>'{group_name}'</i>. | envió {group_notification_count} mensajes nuevos en la conversación <i>'{group_name}'</i>. |_| envió {group_notification_count} mensajes nuevos en la conversación <i>'{group_name}'</i>."
          },
          "not_interested": "no muestra interés en la decisión <i>'{notifiable_name}'</i>.",
          "published": {
            "partners": "inició la decisión <i>'{notifiable_name}'</i>. | inició {group_notification_count} decisiones de <i>'{group_name}'</i>. |_| inició {group_notification_count} decisiones de <i>'{group_name}'</i>."
          }
        },
        "decision_document": {
          "create": "subió el documento <i>'{notifiable_name}'</i> en la decisión <i>'{group_name}'</i>. | subió {group_notification_count} documentos en la decisión <i>'{group_name}'</i>. |_| subió {group_notification_count} documentos en la decisión <i>'{group_name}'</i>."
        },
        "decision_proposal": {
          "approved": "aprobó la propuesta <i>'{notifiable_name}'</i> en la decisión <i>'{group_name}'</i>. | aprobó la propuesta <i>'{notifiable_name}'</i> en la decisión <i>'{group_name}'</i>. | aprobó una propuesta en la decisión <i>'{group_name}'</i>. | aprobó propuestas en la decisión <i>'{group_name}'</i>.",
          "create": "creó la propuesta <i>'{notifiable_name}'</i> en la decisión <i>'{group_name}'</i>. | creó {group_notification_count} propuestas en la decisión <i>'{group_name}'</i>. |_| creó {group_notification_count} propuestas en la decisión <i>'{group_name}'</i>.",
          "requested_changes": "solicita cambios para la propuesta <i>'{notifiable_name}'</i> en la decisión <i>'{group_name}'</i>. | solicita cambios para {group_notification_count} propuestas en la decisión <i>'{group_name}'</i>. |_| solicita cambios para {group_notification_count} propuestas en la decisión <i>'{group_name}'</i>."
        },
        "document": {
          "create": "compartió el documento <i>'{notifiable_name}'</i> contigo. | compartió {group_notification_count} documentos contigo. |_| compartió {group_notification_count} documentos contigo.",
          "proposal": {
            "create": "añadió el documento <i>'{notifiable_name}'</i> a la propuesta <i>'{group_name}'</i>. | añadió {group_notification_count} documentos a la propuesta <i>'{group_name}'</i>. |_| añadió {group_notification_count} documentos a la propuesta <i>'{group_name}'</i>."
          }
        },
        "export": {
          "create": "Tus datos exportados están listos para descargar."
        },
        "issue": {
          "status": {
            "update": "actualizó el estado de una incidencia en <i>'{group_name}'</i>. | actualizó el estado de {group_notification_count} incidencias en <i>'{group_name}'</i>. |_| actualizó el estado de {group_notification_count} incidencias en <i>'{group_name}'</i>."
          }
        },
        "issue_list": {
          "published": "publicó la lista de incidencias <i>'{notifiable_name}'</i> | publicó la lista de incidencias <i>'{notifiable_name}'</i> para {group_notification_count} unidades |_| publicó la lista de incidencias <i>'{notifiable_name}'</i> para {group_notification_count} unidades"
        },
        "reminder": {
          "due": "<i>'{notifiable_name}'</i> no se ha decidido para la unidad {level_name}."
        },
        "ticket_document": {
          "create": "subió el documento <i>'{notifiable_name}'</i> en la conversación <i>'{group_name}'</i>. | subió {group_notification_count} documentos en la conversación <i>'{group_name}'</i>. |_| subió {group_notification_count} documentos en la conversación <i>'{group_name}'</i>."
        },
        "unit": {
          "visibled": "ha añadido al cliente <i>'{customer_group_name}'</i> a <i>'{group_name}'</i> para la unidad <i>'{notifiable_name}'</i>."
        }
      },
      "title": "Notificaciones"
    }
  }
}
